var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayoutWrapper',{attrs:{"page":"courses/index"}},[_c('DefaultCoursesView',{attrs:{"page-content":_vm.pageContent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }